export const requiredValidator = value => {
  return value && String(value).length > 0;
};



// WEBPACK FOOTER //
// ./src/components/field_group/validators.js